import styled from 'styled-components';

const Wrapper = styled.div`
	text-align: center;
	h3 {
		font-family: HaasGrotDisp, -apple-system, system-ui;
		font-weight: bold;
		font-size: 24px;

		margin-bottom: 22px;
	}

	.btn-area {
		font-size: 12px;
		margin-top: 12px;
		color: #b9b9b9;
	}
`;

export default Wrapper;
